import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick, watch } from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import '~/assets/css/swiper.css';
import { useMagicKeys, onClickOutside } from '@vueuse/core';
import { CdnImg } from '@webplatform/cdn-image';
import { ImageWithAltType } from '~/helpers/prepareImagesWithAlts';

interface Props {
  images: ImageWithAltType[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiImagesGallery',
  props: {
    images: null
  },
  setup(__props: any, { expose }) {



const swiperOptions = {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

const isOpen = ref(false);
const swiper = ref<any>(null);

const open = (index: number) => {
  isOpen.value = true;
  nextTick(() => {
    swiper.value?.$swiper.slideToLoop(index, 0, false);
  });
};

const close = () => {
  isOpen.value = false;
};

const { escape } = useMagicKeys();

watch(escape, (v) => {
  if (!v) return;
  if (isOpen.value === false) return;
  close();
});

const modal = ref(null);
onClickOutside(modal, () => close());
expose({
  open,
  close,
});

return { __sfc: true,swiperOptions, isOpen, swiper, open, close, escape, modal, Swiper, SwiperSlide, CdnImg }
}

})